import axios from 'axios'

export default axios.create({
    baseURL: process.env.VUE_APP_PAYMENT_SERVICE_ENDPOINT,
    timeout: 15000,
})
